//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";

export default {
  props: {
    project: Object
  },
  methods: {
    visitProject: function() {
      window.location = this.project.url;
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/projects-map/ProjectMapCard.vue